import React, { ReactNode } from 'react';
import { Trans } from 'react-i18next';

import { transAuthor } from '@/views/Stream/utils';
import { StreamAction, StreamNotification, NotificationSource } from './type';
import { getTimeInFeed } from '@/utils';

const ActionDescMap: Record<StreamAction, ReactNode> = {
  mention: <Trans i18nKey="StreamNotification.dmention"></Trans>,
  repost: <Trans i18nKey="StreamNotification.drepost"></Trans>,
  trust: <Trans i18nKey="StreamNotification.drepost"></Trans>,
  distrust: <Trans i18nKey="StreamNotification.drepost"></Trans>,
  comment: <Trans i18nKey="StreamNotification.dcomment"></Trans>,
  follow: <Trans i18nKey="StreamNotification.dfollow"></Trans>,
  draw_finish: '',
  draw_win: '',
  group_pin: '',
  prime_post_nominated: '',
  prime_post_picked: '',
  quality_content_reward: '',
};

const ActionMap: Record<StreamAction, ReactNode> = {
  mention: <Trans i18nKey="StreamNotification.amention"></Trans>,
  repost: <Trans i18nKey="StreamNotification.areposted"></Trans>,
  trust: <Trans i18nKey="StreamNotification.atrusted"></Trans>,
  distrust: <Trans i18nKey="StreamNotification.adistrusted"></Trans>,
  comment: <Trans i18nKey="StreamNotification.acommented"></Trans>,
  follow: <Trans i18nKey="StreamNotification.afollowed"></Trans>,
  draw_finish: <Trans i18nKey="StreamNotification.adrawfinish"></Trans>,
  draw_win: <Trans i18nKey="StreamNotification.adrawwin"></Trans>,
  group_pin: '',
  prime_post_nominated: '',
  prime_post_picked: '',
  quality_content_reward: '',
};

// 根据title字段来决定是否旧数据。不能根据action类型来判断，因为取值方式有变化。
const isNewNotification = (item: StreamNotification) => {
  return Boolean(item.title);
};

export const transFormRes = (res: StreamNotification) => {
  const firstUser = res.action_users[0];
  const userName = transAuthor({ user: firstUser });
  const moreCount = res.count - 1;
  res._userName = userName;
  res._moreCount = moreCount;
  res._daytime = getTimeInFeed(res.update_at);

  if (isNewNotification(res)) {
    res._actionDesc = '';
    res._action = res.title || '';
    res._target = res.source_url || '';
    res._sourceDesc = res.description || '';
  } else {
    res._actionDesc = ActionDescMap[res.action];
    res._action = ActionMap[res.action];
    res._target = getTargetPath({ source: res.source.type, id: res.source.id });
    res._sourceDesc = res?.source?.summary;
  }
};

const getTargetPath = ({ source, id }: { source: NotificationSource; id: string }) => {
  if (source === 'article') {
    return `stream/${id}`;
  }
  if (source === 'user') {
    return `profile/${id}/follower`;
  }
  return '';
};

export const isStreamNotification = (action: StreamAction) => {
  return ['draw_win', 'draw_finish'].indexOf(action) !== -1;
};

export const isPrimePostNotification = (action: StreamAction) => {
  return ['prime_post_nominated', 'prime_post_picked', 'quality_content_reward'].includes(action);
};
